var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep601(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49.9,
    r: 48.1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.1 74.9c-3.5 0-6.7-0.8-9.6-2.5-2.8-1.7-5.1-4.1-6.8-7.4-1.7-3.2-2.5-7.2-2.5-11.9 0-2.9 0.6-5.7 1.7-8.4s2.6-5.3 4.6-7.8c1.9-2.5 4.2-4.8 6.7-7 2.6-2.2 5.3-4.1 8.2-5.8l7.1 7.7c-3.9 1.5-7.1 3.5-9.7 5.9-2.5 2.4-4.3 4.9-5.5 7.4s-1.8 4.9-1.8 7.1l-2.7-0.3c1.3-3.1 3-5.5 5.1-7.2s5-2.6 8.7-2.6c2.4 0 4.6 0.7 6.9 2s4 3.2 5.4 5.5c1.4 2.4 2.1 5.1 2.1 8.3 0 3.6-0.9 6.7-2.6 9.2s-4 4.5-6.7 5.8-5.6 2-8.6 2zm-0.5-9.6c1.4 0 2.7-0.3 3.8-0.8 1.1-0.6 2-1.4 2.6-2.5s1-2.4 1-4c0-1.5-0.3-2.8-1-3.8s-1.5-1.8-2.7-2.3c-1.1-0.5-2.3-0.8-3.7-0.8s-2.6 0.3-3.7 0.8-2 1.2-2.7 2.1-1 1.8-1 2.8v1.8c0 1.2 0.3 2.3 1 3.3 0.6 1 1.5 1.9 2.7 2.5 1.1 0.6 2.3 0.9 3.7 0.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep601);
export default __webpack_public_path__ + "static/media/step6-01.e674e8c7eec5336614fae9b7d100dae4.svg";
export { ForwardRef as ReactComponent };